import { NgModule } from '@angular/core';
import { DistancePipe } from '@paystory/pipes/distance/distance.pipe';

@NgModule({
    declarations: [DistancePipe],
    exports: [DistancePipe],
})
export class DistancePipeModule {}
